import React, { Component } from 'react';
import * as Table from 'reactabular-table';
import * as sort from 'sortabular';
import * as Search from 'searchtabular';
import {
  Glyphicon,
  OverlayTrigger,
  Tooltip,
  Button,
  PageHeader,
  Grid,
  Row,
  Col,
  Pagination,
} from 'react-bootstrap';
import { orderBy, map } from 'lodash';
import { getTariffRates, removeTariffRate } from 'utils/TariffRatesAPIUtils';
import { updateContract } from 'utils/ContractsAPIUtils';
import TariffRatesEditModal from './TariffRatesEditModal';
import paginate from 'utils/pagination-util';
import Store from 'stores/TariffRatesStore';

export default class TariffList extends Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};
    const sortable = sort.sort({
      getSortingColumns,
      onSort: (selectedColumn) => {
        this.setState({
          sortingColumns: sort.byColumns({
            // sort.byColumn would work too
            sortingColumns: this.state.sortingColumns,
            selectedColumn,
          }),
        });
      },
    });
    this.state = {
      tariffRates: [],
      editedCell: null,
      query: {},
      searchColumn: 'all',
      sortingColumns: null,
      showEditor: false,
      columns: [
        {
          property: 'name',
          header: {
            label: 'Name',
            formatters: [
              sort.header({
                sortable,
                getSortingColumns,
                strategy: sort.strategies.byProperty,
              }),
            ],
          },
          cell: {
            formatters: [Search.highlightCell],
          },
        },
        {
          property: 'type',
          header: {
            label: 'Type',
            formatters: [
              sort.header({
                sortable,
                getSortingColumns,
                strategy: sort.strategies.byProperty,
              }),
            ],
          },
          cell: {
            formatters: [Search.highlightCell],
          },
        },
        {
          header: {
            formatters: [
              () => (
                <Button
                  bsSize="xsmall"
                  className="btn btn-default"
                  onClick={this.newTariffRate()}
                >
                  New TariffRate
                </Button>
              ),
            ],
          },
          cell: {
            formatters: [
              (value, { rowData }) => {
                const tariffRate = rowData;

                const remove = (password) => {
                  this.handleTariffRateDelete(tariffRate, password);
                };

                const edit = () => {
                  this.setState({ showEditor: true, tariffRate: tariffRate });
                };

                return (
                  <span>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="remove">Remove</Tooltip>}
                    >
                      <Glyphicon
                        glyph="remove"
                        style={{ cursor: 'pointer', color: 'red' }}
                        onClick={remove}
                      />
                    </OverlayTrigger>
                    &nbsp;
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="edit">Edit</Tooltip>}
                    >
                      <Glyphicon
                        glyph="edit"
                        style={{ cursor: 'pointer', color: 'green' }}
                        onClick={edit}
                      />
                    </OverlayTrigger>
                  </span>
                );
              },
            ],
          },
        },
      ],
      pagination: {
        page: 0,
        perPage: 10,
      },
    };
    this.onChange = () => this.onStoreChange();
  }

  componentDidMount() {
    Store.addChangeListener(this.onChange);
    if (this.props.contract._id) {
      getTariffRates(this.props.contract._id);
    } else {
      Store.clearAll();
    }
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  onStoreChange() {
    this.setState({ tariffRates: Store.getTariffRates() }, () => {
      if (Store.getIsAddOrRemove()) {
        const contract = this.props.contract;
        if (contract) {
          contract.tariff_rates = map(Store.getTariffRates(), '_id');
          updateContract(contract);
        }
        Store.setIsAddOrRemove();
      }
    });
  }

  onSearch(search) {
    this.setState({
      editedCell: null,
      search: search,
    });
  }

  newTariffRate() {
    return () => {
      this.setState({ showEditor: true });
    };
  }

  handleTariffRateDelete(tariffRate, password) {
    if (tariffRate) {
      Store.reset();
      removeTariffRate(tariffRate, password);
    }
  }

  onPerPage = (e) => {
    const pagination = this.state.pagination || {};
    pagination.perPage = parseInt(e.target.value, 10);
    this.setState({
      pagination: pagination,
    });
  };

  onSelect(eventKey) {
    const pagination = this.state.pagination || {};
    pagination.page = eventKey - 1;
    this.setState({
      pagination: pagination,
    });
  }

  render() {
    let tariffRates = this.state.tariffRates;
    const columns = this.state.columns;
    const searchColumn = this.state.searchColumn;
    const pagination = this.state.pagination;
    const query = this.state.query;
    const showEditor = this.state.showEditor;
    const sortingColumns = this.state.sortingColumns;
    if (tariffRates && query) {
      tariffRates = Search.highlighter({
        columns: columns,
        matches: Search.matches,
        query,
      })(Search.multipleColumns({ columns, query })(tariffRates));
    }
    tariffRates = sort.sorter({
      columns: columns,
      sortingColumns,
      sort: orderBy,
    })(tariffRates);
    let totalPages = 0;
    if (pagination.perPage && tariffRates) {
      totalPages = Math.ceil(tariffRates.length / pagination.perPage);
    }

    const tariffRate = this.state.tariffRate;
    const paginated = paginate(tariffRates, pagination);
    const close = () => {
      this.setState({ showEditor: false, tariffRate: null });
    };
    let modal = <div />;
    if (showEditor) {
      modal = (
        <TariffRatesEditModal
          className="contract-wrapper"
          tariffRate={tariffRate}
          onClose={close}
          show
        />
      );
    }
    return (
      <div className="contract-wrapper">
        <PageHeader>TariffRates</PageHeader>
        <Grid fluid>
          <Row className="show-grid row-centered">
            <Col xs={4} className="fixed col-left">
              <label>
                Per page{' '}
                <input
                  type="number"
                  defaultValue={pagination.perPage}
                  onChange={this.onPerPage}
                />
              </label>
            </Col>
            <Col xs={4} className="col-centered">
              <h4>{`Page ${pagination.page + 1} of ${totalPages}`}</h4>
            </Col>
            <Col xs={4} className="col-right">
              <div className="search-container">
                <span>Search</span>
                <Search.Field
                  column={searchColumn}
                  query={query}
                  data={this.state.tariffRates}
                  columns={columns}
                  rows={paginated.data}
                  onColumnChange={(searchColumn) =>
                    this.setState({ searchColumn })
                  }
                  onChange={(query) => this.setState({ query })}
                />
              </div>
            </Col>
          </Row>
        </Grid>
        <div>
          <Table.Provider
            className="default-table"
            columns={columns}
          >
            <Table.Header />
            <Table.Body rows={paginated.data} rowKey="_id" />
          </Table.Provider>
        </div>
        <div className="controls">
          <Pagination
            prev
            next
            first
            last
            ellipsis
            items={paginated.amount}
            maxButtons={5}
            activePage={pagination.page + 1}
            onSelect={(eventKey) => this.onSelect(eventKey)}
          />
        </div>
        <div>{modal}</div>
      </div>
    );
  }
}
